module.exports = __webpack_public_path__ + "img/appltCourse-img4.773cdfca.png";